/* Rupe — barra acquisto fissa in pagina prodotto.
   Compare quando il bottone "Aggiungi al carrello" vero esce dallo schermo (verso l'alto o verso il basso),
   mostra prezzo e taglia scelta, e al clic preme il bottone vero (o porta alla scelta taglia se manca). */
(function () {
  'use strict';
  function init() {
    var bar = document.querySelector('[data-rupe-sticky]'); if (!bar || bar.__rs) return; bar.__rs = true;
    try { init2(bar); } catch (e) { if (window.console) console.warn('rupe-sticky', e); }
  }
  function init2(bar) {
    var form = bar.closest('product-form') || document.querySelector('product-form'); if (!form) return;
    // la barra è position:fixed, ma stava dentro la colonna "sticky" del prodotto (che crea un contesto di impilamento):
    // altre sezioni più in basso (es. "Ti potrebbe piacere anche") finivano sopra. Spostandola in <body> sta sempre davanti.
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    var real = function () { return form.querySelector('button[type="submit"], button[name="add"], .add-to-cart'); };
    var btn = bar.querySelector('[data-rupe-sticky-btn]'), priceEl = bar.querySelector('[data-rupe-sticky-price]'), sizeEl = bar.querySelector('[data-rupe-sticky-size]');
    var picker = function () { return form.closest('.detail, .product-column-right, section, main') || document; };
    function selectedSize() {
      var scope = picker();
      var r = Array.prototype.filter.call(scope.querySelectorAll('input[type="radio"]:checked'), function (x) { return /taglia|size|taille|gr[öo]ße/i.test(x.name + ' ' + ((x.closest('fieldset') || {}).textContent || '')); })[0];
      if (r) return r.value;
      var s = Array.prototype.filter.call(scope.querySelectorAll('select'), function (x) { return /taglia|size|taille/i.test(x.name + ' ' + x.id); })[0];
      return s && s.value && !/scegli|choose|select|choisir/i.test(s.value) ? s.value : null;
    }
    function sync() {
      var rb = real();
      var price = picker().querySelector('.price .current-price, .price-area .current-price, .current-price');
      if (price && priceEl) priceEl.textContent = price.textContent.trim();
      var sz = selectedSize(); if (sizeEl) sizeEl.textContent = sz || '';
      if (rb && (rb.disabled || /esaurit|sold out|épuisé|ausverkauft/i.test(rb.textContent))) { btn.textContent = btn.getAttribute('data-t-soldout'); btn.disabled = true; btn.setAttribute('data-state', 'soldout'); }
      else if (!sz) { btn.textContent = btn.getAttribute('data-t-pick'); btn.disabled = false; btn.setAttribute('data-state', 'pick'); }
      else { btn.textContent = btn.getAttribute('data-t-add'); btn.disabled = false; btn.setAttribute('data-state', 'add'); }
    }
    // senza taglia scelta, il bottone vero non deve fare nulla in silenzio: porta al selettore e mostra "Scegli una taglia"
    function pickMsg() {
      var t = picker().querySelector('.input-row--variant-picker, .option-selector') || real();
      if (!t) return;
      var m = t.querySelector('.rupe-pick-msg') || document.createElement('div');
      m.className = 'rupe-pick-msg'; m.setAttribute('role', 'alert'); m.textContent = btn.getAttribute('data-t-pick');
      if (!m.parentNode) t.appendChild(m);
      t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      m.classList.remove('is-flash'); void m.offsetWidth; m.classList.add('is-flash');
    }
    document.addEventListener('click', function (e) {
      var rb = e.target && e.target.closest && e.target.closest('product-form button[type="submit"], product-form button[name="add"]');
      if (!rb || rb === btn) return;
      var sel = picker().querySelector('input[type="radio"]'); if (!sel) return; // prodotto senza taglie
      if (selectedSize()) return;
      e.preventDefault(); e.stopPropagation(); pickMsg();
    }, true);
    btn.addEventListener('click', function () {
      var rb = real();
      if (btn.getAttribute('data-state') === 'pick') { pickMsg(); return; }
      if (rb) rb.click();
    });
    // il bottone della chat (Shopify Inbox, dentro due shadow DOM aperti) va alzato sopra la barra: gli si passa un attributo
    // e una regola di stile iniettata nel suo shadow root; se la chat non è ancora caricata si riprova per qualche secondo
    function liftChat(on, tries) {
      var host = document.querySelector('shopify-chat'), rt = host && host.shadowRoot && host.shadowRoot.querySelector('shopify-agent-runtime'), sr = rt && rt.shadowRoot;
      if (!sr) { if (on && (tries || 0) < 10) setTimeout(function () { liftChat(on, (tries || 0) + 1); }, 1000); return; }
      if (!sr.__rupeLift) { var st = document.createElement('style'); st.textContent = ':host([data-rupe-lift]) .activator-nudge{bottom:var(--rupe-lift,96px) !important}'; sr.appendChild(st); sr.__rupeLift = true; }
      rt.style.setProperty('--rupe-lift', (bar.offsetHeight + 12) + 'px');
      if (on) rt.setAttribute('data-rupe-lift', ''); else rt.removeAttribute('data-rupe-lift');
    }
    var show = function (on) { bar.hidden = false; bar.setAttribute('aria-hidden', String(!on)); bar.classList.toggle('is-on', on); document.body.classList.toggle('rupe-sticky-on', on); liftChat(on, 0); };
    sync();
    var rb0 = real();
    if (!rb0 || !window.IntersectionObserver) return;
    // la barra compare solo dopo aver superato il bottone vero (bottone uscito dallo schermo verso l'alto),
    // su telefono come su desktop; prima di arrivarci non si vede
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var passed = e.boundingClientRect.top < 0; // bottone sopra lo schermo
        show(!e.isIntersecting && passed);
      });
    }, { threshold: 0 }).observe(rb0);
    document.addEventListener('change', function (e) { if (e.target && (e.target.matches('input[type="radio"]') || e.target.matches('select'))) setTimeout(sync, 50); });
    new MutationObserver(function () { clearTimeout(bar.__t); bar.__t = setTimeout(sync, 80); }).observe(picker(), { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
